import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4c0a59a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor nodeEditor" }
const _hoisted_2 = { class: "nodeTitle" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Name: ")
const _hoisted_5 = { class: "section" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Final:  ")

import {ref, computed, watch} from "vue"
import Toggle from "@vueform/toggle";
import {State} from "@/assets/types"



export default /*#__PURE__*/_defineComponent({
  props: {
    nodeId: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props as {
    nodeId: string;
    modelValue: State;    
}



const final = ref(props.modelValue.final)
const name = ref(props.modelValue.name)

const state = computed<State>( () => {
    return{
        name: name.value,
        final: final.value
    }
})

watch(()=>props.nodeId, async ()=>{
    final.value = props.modelValue.final
    name.value = props.modelValue.name
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, "Node: " + _toDisplayString(name.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Nome nodo",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', _unref(state))))
      }, null, 544), [
        [_vModelText, name.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_unref(Toggle), {
        id: "finalToggle",
        class: "toggle",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', _unref(state)))),
        modelValue: final.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((final).value = $event)),
        "on-label": "on",
        "off-label": "off"
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})